// https://developers.google.com/youtube/iframe_api_reference

// Inject YouTube API script
var tag = document.createElement('script');
tag.src = "//www.youtube.com/player_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// global variable for the player
var player_fine_01, player_fine_02,
  player_frizzy_01, player_frizzy_02,
  player_normalcomb_01, player_normalcomb_02,
  player_oily_01, player_oily_02,
  player_colortreated_01, player_colortreated_02,
  player_wavycurly_01, player_wavycurly_02,
  player_drydamaged_01, player_drydamaged_02;

// this function gets called when API is ready to use
function onYouTubePlayerAPIReady() {
    // create the global player from the specific iframe (#video)
    player_fine_01 = new YT.Player('hair_guide_fine_video_01', {
        events: {
        // call this function when player is ready to use
        'onReady': onPlayerReady_fine_01,
        'onStateChange': onPlayerStateChange_fine_01
        }
    });

    player_fine_02 = new YT.Player('hair_guide_fine_video_02', {
        events: {
        // call this function when player is ready to use
        'onReady': onPlayerReady_fine_02,
        'onStateChange': onPlayerStateChange_fine_02
        }
    });

    player_frizzy_01 = new YT.Player('hair_guide_frizzy_video_01', {
        events: {
            // call this function when player is ready to use
            'onReady': onPlayerReady_frizzy_01,
            'onStateChange': onPlayerStateChange_frizzy_01
        }
    });

    player_frizzy_02 = new YT.Player('hair_guide_frizzy_video_02', {
        events: {
            // call this function when player is ready to use
            'onReady': onPlayerReady_frizzy_02,
            'onStateChange': onPlayerStateChange_frizzy_02
        }
    });

  player_normalcomb_01 = new YT.Player('hair_guide_normalcomb_video_01', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_normalcomb_01,
      'onStateChange': onPlayerStateChange_normalcomb_01
    }
  });

  player_normalcomb_02 = new YT.Player('hair_guide_normalcomb_video_02', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_normalcomb_02,
      'onStateChange': onPlayerStateChange_normalcomb_02
    }
  });

  player_oily_01 = new YT.Player('hair_guide_oily_video_01', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_oily_01,
      'onStateChange': onPlayerStateChange_oily_01
    }
  });

  player_oily_02 = new YT.Player('hair_guide_oily_video_02', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_oily_02,
      'onStateChange': onPlayerStateChange_oily_02
    }
  });

  player_colortreated_01 = new YT.Player('hair_guide_colortreated_video_01', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_colortreated_01,
      'onStateChange': onPlayerStateChange_colortreated_01
    }
  });

  player_colortreated_02 = new YT.Player('hair_guide_colortreated_video_02', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_colortreated_02,
      'onStateChange': onPlayerStateChange_colortreated_02
    }
  });

  player_wavycurly_01 = new YT.Player('hair_guide_wavycurly_video_01', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_wavycurly_01,
      'onStateChange': onPlayerStateChange_wavycurly_01
    }
  });

  player_wavycurly_02 = new YT.Player('hair_guide_wavycurly_video_02', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_wavycurly_02,
      'onStateChange': onPlayerStateChange_wavycurly_02
    }
  });

  player_drydamaged_01 = new YT.Player('hair_guide_drydamaged_video_01', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_drydamaged_01,
      'onStateChange': onPlayerStateChange_drydamaged_01
    }
  });

  player_drydamaged_02 = new YT.Player('hair_guide_drydamaged_video_02', {
    events: {
      // call this function when player is ready to use
      'onReady': onPlayerReady_drydamaged_02,
      'onStateChange': onPlayerStateChange_drydamaged_02
    }
  });
}

function onPlayerReady_fine_01(event) {  
    $(document).on('click', '#hair_guide_fine_01', function () {
        $(this).fadeOut('normal');
        player_fine_01.playVideo();
    });
}

function onPlayerReady_fine_02(event) {  
    $(document).on('click', '#hair_guide_fine_02', function () {
        $(this).fadeOut('normal');
        player_fine_02.playVideo();
    });
}

function onPlayerReady_frizzy_01(event) {
    $(document).on('click', '#hair_guide_frizzy_01', function () {
        $(this).fadeOut('normal');
        player_frizzy_01.playVideo();
    });
}

function onPlayerReady_frizzy_02(event) {
    $(document).on('click', '#hair_guide_frizzy_02', function () {
        $(this).fadeOut('normal');
        player_frizzy_02.playVideo();
    });
}

function onPlayerReady_normalcomb_01(event) {
  $(document).on('click', '#hair_guide_normalcomb_01', function () {
    $(this).fadeOut('normal');
    player_normalcomb_01.playVideo();
  });
}

function onPlayerReady_normalcomb_02(event) {
  $(document).on('click', '#hair_guide_normalcomb_02', function () {
    $(this).fadeOut('normal');
    player_normalcomb_02.playVideo();
  });
}

function onPlayerReady_oily_01(event) {
  $(document).on('click', '#hair_guide_oily_01', function () {
    $(this).fadeOut('normal');
    player_oily_01.playVideo();
  });
}

function onPlayerReady_oily_02(event) {
  $(document).on('click', '#hair_guide_oily_02', function () {
    $(this).fadeOut('normal');
    player_oily_02.playVideo();
  });
}

function onPlayerReady_colortreated_01(event) {
  $(document).on('click', '#hair_guide_colortreated_01', function () {
    $(this).fadeOut('normal');
    player_colortreated_01.playVideo();
  });
}

function onPlayerReady_colortreated_02(event) {
  $(document).on('click', '#hair_guide_colortreated_02', function () {
    $(this).fadeOut('normal');
    player_colortreated_02.playVideo();
  });
}

function onPlayerReady_wavycurly_01(event) {
  $(document).on('click', '#hair_guide_wavycurly_01', function () {
    $(this).fadeOut('normal');
    player_wavycurly_01.playVideo();
  });
}

function onPlayerReady_wavycurly_02(event) {
  $(document).on('click', '#hair_guide_wavycurly_02', function () {
    $(this).fadeOut('normal');
    player_wavycurly_02.playVideo();
  });
}

function onPlayerReady_drydamaged_01(event) {
  $(document).on('click', '#hair_guide_drydamaged_01', function () {
    $(this).fadeOut('normal');
    player_drydamaged_01.playVideo();
  });
}

function onPlayerReady_drydamaged_02(event) {
  $(document).on('click', '#hair_guide_drydamaged_02', function () {
    $(this).fadeOut('normal');
    player_drydamaged_02.playVideo();
  });
}

function onPlayerStateChange_fine_01(event) {
    if (event.data == YT.PlayerState.ENDED) {
        $('#hair_guide_fine_01').fadeIn('normal');
    }
}

function onPlayerStateChange_fine_02(event) {
    if (event.data == YT.PlayerState.ENDED) {
        $('#hair_guide_fine_02').fadeIn('normal');
    }
}

function onPlayerStateChange_frizzy_01(event) {
    if (event.data == YT.PlayerState.ENDED) {
        $('#hair_guide_frizzy_01').fadeIn('normal');
    }
}

function onPlayerStateChange_frizzy_02(event) {
    if (event.data == YT.PlayerState.ENDED) {
        $('#hair_guide_frizzy_02').fadeIn('normal');
    }
}

function onPlayerStateChange_normalcomb_01(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_normalcomb_01').fadeIn('normal');
  }
}

function onPlayerStateChange_normalcomb_02(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_normalcomb_02').fadeIn('normal');
  }
}

function onPlayerStateChange_oily_01(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_oily_01').fadeIn('normal');
  }
}

function onPlayerStateChange_oily_02(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_oily_02').fadeIn('normal');
  }
}

function onPlayerStateChange_colortreated_01(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_colortreated_01').fadeIn('normal');
  }
}

function onPlayerStateChange_colortreated_02(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_colortreated_02').fadeIn('normal');
  }
}

function onPlayerStateChange_wavycurly_01(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_wavycurly_01').fadeIn('normal');
  }
}

function onPlayerStateChange_wavycurly_02(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_wavycurly_02').fadeIn('normal');
  }
}

function onPlayerStateChange_drydamaged_01(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_drydamaged_01').fadeIn('normal');
  }
}

function onPlayerStateChange_drydamaged_02(event) {
  if (event.data == YT.PlayerState.ENDED) {
    $('#hair_guide_drydamaged_02').fadeIn('normal');
  }
}